import * as React from 'react'
import Image from 'next/image'

import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Icon from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'
import { Path } from 'types/types'

const GoalLists = styled('div')`
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
    ${(props) => props.theme.breakpoints.up('sm')} {
        padding-left: 2rem;
    }
`

const UserGoals = (props: Path) => {
    const { t }: I18n = useTranslation()

    return (
        <div>
            <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                <Icon fontSize="small" color="primary" name="helpOutline" />
                <Text sx={{ textTransform: 'uppercase', fontWeight: 'bold' }} color="primary">
                    {t('path:targetSection.label')}
                </Text>
            </Stack>
            <Text variant="h4">{t('path:targetSection.targetTitle')}</Text>
            <GoalLists>
                {props.user_goals.map((item) => (
                    <Stack direction="row" key={item} spacing="1rem">
                        <Image height={25} width={25} src={'/assets/list-bullet.png'} objectFit="contain" alt="" />
                        <Text flex={2} variant="h6" color="text.secondary">
                            {item}
                        </Text>
                    </Stack>
                ))}
            </GoalLists>
        </div>
    )
}

export default UserGoals
